/* Open-on-hover for the Mariager-managed mega menu (snippets/cph-mega-menu.liquid).
   Dawn opens <details> on click; mouse users expect hover, as the old menu did.
   Touch and keyboard keep Dawn's click/Enter behaviour untouched.

   A panel opens when the pointer enters its tab. It closes only when the
   pointer (a) leaves the panel itself, (b) leaves the header altogether, or
   (c) enters another tab. Leaving the tab towards the panel never closes it,
   so the strip of header between the two is safe to cross at any speed.

   Clicking a mega tab that has an overview link (data-href) navigates there. */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const nav = document.querySelector('.cph-menu');
  if (!nav) return;
  const header = nav.closest('.header-wrapper') || nav.closest('header') || nav;

  let closeTimer = null;
  const summaryOf = (details) => details.querySelector('summary');
  const openPanels = () => nav.querySelectorAll('details[open]');

  const close = (details) => {
    if (!details.open) return;
    details.open = false;
    summaryOf(details).setAttribute('aria-expanded', 'false');
  };
  const closeAll = (except) => openPanels().forEach((d) => { if (d !== except) close(d); });
  const scheduleCloseAll = () => {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => closeAll(), 160);
  };
  const cancelClose = () => window.clearTimeout(closeTimer);

  const open = (details) => {
    cancelClose();
    closeAll(details);
    if (details.open) return;
    details.open = true;
    summaryOf(details).setAttribute('aria-expanded', 'true');
  };

  nav.querySelectorAll(':scope > ul > li').forEach((li) => {
    const menu = li.querySelector('header-menu');
    const details = menu && menu.querySelector('details');
    if (!details) {
      // Plain link tab: hovering it dismisses whatever panel is open.
      li.addEventListener('mouseenter', () => { cancelClose(); closeAll(); });
      return;
    }
    menu.addEventListener('mouseenter', () => open(details));
    // A tab with an overview page (e.g. Producenter) goes there on click, since
    // hover already shows the panel. Keyboard Enter (detail 0) still toggles it.
    const href = summaryOf(details).dataset.href;
    if (href) {
      summaryOf(details).addEventListener('click', (event) => {
        if (event.detail === 0) return;
        event.preventDefault();
        if (event.ctrlKey || event.metaKey || event.shiftKey) window.open(href, '_blank', 'noopener');
        else window.location.assign(href);
      });
      summaryOf(details).addEventListener('auxclick', (event) => {
        if (event.button === 1) window.open(href, '_blank', 'noopener');
      });
    }
    const panel = details.querySelector('.mega-menu__content');
    if (panel) {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleCloseAll);
    }
  });

  header.addEventListener('mouseleave', scheduleCloseAll);
  header.addEventListener('mouseenter', cancelClose);
})();
